import axiosInstance from "../../../helpers/api";
import { deleteStudent } from "../students/Api";

export const getAllAssistants = (body) => {
    return axiosInstance.get('/admin/assistants', body);
};

export const editAssistant = (formData) => {
    return axiosInstance.put(`/admin/assistants/${formData.id}`, formData.formData);
};

export const createAssistant = (formData) => {
    return axiosInstance.post('/admin/assistants', formData);
};

export const deleteAssistant = (id) => {
    return deleteStudent(id);
};

export const suspendAssistant = (id, reason) => {
    return deleteStudent(id, reason);
};

